/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 */

import { selectGlobalNavHFRLinks } from '@zcode-ui/web-zumper-global-state'
import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { TRACK_USER_MENU_ACTION } from '../../../../constants'
import { usePathname } from '../../../../hooks/usePathname'
import {
  type ExtraNavLink,
  getHFRMenuNavDefaultLinks,
  getMenuNavLinks,
} from '../../../../utils/getMenuNavLinks'
import { UserLinksSubmenu } from '../UserLinksSubmenu'

interface HFRUserSubmenuProps {
  onLinkClick: (name: string, href: string) => void
}

const EXTRA_LINKS = [
  {
    name: 'Near Me',
    href: '/near-me/houses',
    title: 'Houses for rent near me',
    is_indexed: true,
    trackingName: TRACK_USER_MENU_ACTION.HOUSES_FOR_RENT_NEAR_ME,
  },
] as const satisfies ReadonlyArray<ExtraNavLink>

export const HFRUserSubmenu = ({ onLinkClick }: HFRUserSubmenuProps) => {
  const pathName = usePathname()
  const getLocaleLinkTitle = useCallback((name: string) => `Houses for rent ${name}`, [])
  const hfrLinks = useSelector(selectGlobalNavHFRLinks)
  const links = useMemo(
    () =>
      hfrLinks?.length > 0
        ? getMenuNavLinks('/houses-for-rent/', hfrLinks, 15, pathName)
        : getHFRMenuNavDefaultLinks(pathName),
    [hfrLinks, pathName]
  )
  return (
    <UserLinksSubmenu
      extraLinks={EXTRA_LINKS}
      getLocaleLinkTitle={getLocaleLinkTitle}
      links={links}
      onLinkClick={onLinkClick}
    />
  )
}
